import { Http } from '../../shared';
import { settings } from '../../settings';

export class ConfigurationService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.configration_api;
    }

    async getTemplates(query) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            },
            params: query
        }
        var response = await this.http.get(`${this.service_url}/templates`, options);
        return response.data;
    }

}